import { contextFactory } from '@frontend/design-system';
import {
  TerminalStepContextProps,
  TerminalStepContextState,
  useTerminalStepSelectedReader,
} from './terminal-step-context';

export type TerminalStepContextStripeState = TerminalStepContextState;

export const [TerminalStepStripeContext, useTerminalStepStripeContext] = contextFactory<TerminalStepContextStripeState>(
  '',
  {} as TerminalStepContextStripeState
);

export const TerminalStepContextStripe = ({ children }: TerminalStepContextProps) => {
  const value = useTerminalStepSelectedReader();

  return (
    <>
      <TerminalStepStripeContext.Provider value={value}>{children}</TerminalStepStripeContext.Provider>
    </>
  );
};
